<template>
  <div>
    <div v-if="isLoggedIn">
      <div class="dashboard pa-2">
        <h1 class="welcomemsg">{{ t('welcome') }} {{ user }}</h1>
        <v-container class="ml-0">
          <v-row class="pa-6 pl-0 pt-0">
            <v-col cols="auto">
              <router-link to="/products">
                <DashboardProductsStatistics />
              </router-link>
            </v-col>
            <v-col cols="auto">
              <router-link to="/locations">
                <DashboardLocationsStatistics />
              </router-link>
            </v-col>
            <v-col cols="auto">
              <router-link to="/users">
                <DashboardUserStatistics />
              </router-link>
            </v-col>
          </v-row>
        </v-container>
        <div v-if="isUserNotSuper">
          <DashboardRestock />
        </div>
      </div>
    </div>

  
    <div v-else>
      <p v-if="isLoggedIn">Loading dashboard...</p>
      <p v-else>Please log in to access the dashboard</p>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, computed } from 'vue';
  import { useStore } from 'vuex';
  import DashboardUserStatistics from '@/components/dashboard/DashboardUserStatistics.vue';
  import DashboardProductsStatistics from '@/components/dashboard/DashboardProductsStatistics.vue';
  import DashboardLocationsStatistics from '@/components/dashboard/DashboardLocationsStatistics.vue';
//  import DashboardCustomersStatistics from '@/components/dashboard/DashboardCustomersStatistics.vue';
//  import DashboardSuppliersStatistics from '@/components/dashboard/DashboardSuppliersStatistics.vue';
  import DashboardRestock from '@/components/dashboard/DashboardRestock.vue';
  import { useI18n } from 'vue-i18n';


  const store = useStore();
  const color = ref('indigo-darken-3');
  const locationsColor = ref('indigo-darken-4');
  const orderColor = ref('teal-darken-3');
  const user = localStorage.getItem('fullname');
  const language = localStorage.getItem('language') || 'da';
  const userRole = localStorage.getItem('role');
  const isUserNotSuper = computed(() => userRole !== 'super')
  const dashboard = "Dashboard";
  const variant = "elevated";
  const { t } = useI18n();


  onMounted(async () => {
    try {
      if (store.getters['auth/isLoggedIn']) {
      }
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    }
  });

  const isLoggedIn = computed(() => store.getters['auth/isLoggedIn']);
  
</script>

<style scoped>
  .welcomemsg {
    color: #555;
    font-size: 2rem;
    font-weight: 400;
    margin-left: 20px;
    margin-top: 20px;
    margin-bottom: 12px;
  }

  .restock-box {
    position: fixed;     /* Fixed position relative to viewport */
    bottom: 20px;        /* 20px from bottom */
    right: 20px;         /* 20px from right */
    max-width: 300px;    /* Optional: Max width */
    background: #fff;    /* Background color */
    border: 1px solid #ccc; /* Border styling */
    border-radius: 8px;  /* Rounded corners */
    box-shadow: 0 2px 8px rgba(0,0,0,0.2); /* Shadow for pop-up effect */
    padding: 10px;       /* Inner padding */
    z-index: 9999;       /* Overlay on top of other elements */
  }
  </style>